<template>
  <footer class="footer" :class="{ 'footer--compact': compact }">
    <div class="container">
      <div class="footer__content">
        <div class="footer__left">
          <div class="footer__logo">
            <img src="@/assets/logo.png" alt="公司Logo">
            <span class="footer__company-name">遵义市精科信检测有限公司</span>
          </div>
          <p class="footer__desc">专业第三方检验检测机构，提供食品、农产品、药品、化妆品、环境等多领域检测服务</p>
        </div>
        <div class="footer__right">
          <div class="footer__section">
            <h4 class="footer__title">快速链接</h4>
            <ul class="footer__links">
              <li><a href="#" @click.prevent="switchPage('home')">首页</a></li>
              <li><a href="#" @click.prevent="switchPage('about')">关于我们</a></li>
              <li><a href="#" @click.prevent="switchPage('products')">产品中心</a></li>
              <li><a href="#" @click.prevent="switchPage('news')">新闻资讯</a></li>
            </ul>
          </div>
          <div class="footer__section">
            <h4 class="footer__title">联系方式</h4>
            <ul class="footer__contact">
              <li><i class="icon-location"></i>遵义市播州区芶江镇贵州苟江经济开发区</li>
              <li><i class="icon-phone"></i>联系电话：0851-XXXXXXX</li>
              <li><i class="icon-email"></i>邮箱：contact@jingkexin.com</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <p class="footer__copyright">&copy; {{ new Date().getFullYear() }} 遵义市精科信检测有限公司. 保留所有权利.</p>
        <p class="footer__icp">黔ICP备17008112号-2</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    switchPage(page) {
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page }
      }))
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #ffffff;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  padding: 60px 0 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer__content {
  display: flex;
  justify-content: space-between;
  gap: 60px;
  margin-bottom: 40px;
}

.footer__left {
  flex: 1;
  max-width: 400px;
}

.footer__logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.footer__logo img {
  height: 40px;
}

.footer__company-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.footer__desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.footer__right {
  display: flex;
  gap: 60px;
}

.footer__section {
  min-width: 150px;
}

.footer__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.footer__links,
.footer__contact {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer__links li,
.footer__contact li {
  margin-bottom: 10px;
  font-size: 14px;
  color: #666;
}

.footer__links a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.footer__links a:hover {
  color: #007bff;
}

.footer__contact li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.footer__bottom {
  border-top: 1px solid #e9ecef;
  padding-top: 20px;
  text-align: center;
}

.footer__copyright,
.footer__icp {
  font-size: 13px;
  color: #999;
  margin: 0;
  line-height: 1.8;
}

.footer--compact {
  height: 100%;
  padding: 32px 0 16px;
  box-shadow: none;
}

.footer--compact .container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.footer--compact .footer__content {
  margin-bottom: 20px;
  gap: 36px;
}

.footer--compact .footer__left {
  max-width: 360px;
}

.footer--compact .footer__logo {
  margin-bottom: 10px;
}

.footer--compact .footer__logo img {
  height: 36px;
}

.footer--compact .footer__company-name {
  font-size: 16px;
}

.footer--compact .footer__desc,
.footer--compact .footer__links li,
.footer--compact .footer__contact li {
  font-size: 13px;
}

.footer--compact .footer__right {
  gap: 40px;
}

.footer--compact .footer__section {
  min-width: 140px;
}

.footer--compact .footer__title {
  margin-bottom: 12px;
  font-size: 15px;
}

.footer--compact .footer__links li,
.footer--compact .footer__contact li {
  margin-bottom: 8px;
}

.footer--compact .footer__bottom {
  padding-top: 14px;
}

.footer--compact .footer__copyright,
.footer--compact .footer__icp {
  font-size: 12px;
  line-height: 1.6;
}

/* 响应式 */
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer__content {
    flex-direction: column;
    gap: 40px;
  }

  .footer__left {
    max-width: 100%;
  }

  .footer__right {
    flex-direction: column;
    gap: 30px;
  }

  .footer__company-name {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .footer__logo {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .footer__company-name {
    font-size: 14px;
  }
}
</style>
